import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Home from '../views/Home.vue';
import Contact from '../views/Contact.vue';
import About from '../views/About.vue';
import Productos from '../views/Productos.vue';
import Login from '../views/Login.vue';
import Carrito from '../views/Carrito.vue';
import Pedidos from '../views/Pedidos.vue';
import Confirmation from '../views/Confirmation.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/Productos',
        name: 'Productos',
        component: Productos,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/Ofertas',
        name: 'Ofertas',
        component: Productos,
        props: { props: route => ({ query: route.query.lab }), sales: true },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/Carrito',
        name: 'Carrito',
        component: Carrito,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/Pedidos',
        name: 'Pedidos',
        component: Pedidos
    },
    {
        path: '/Confirmation',
        name: 'Confirmation',
        component: Confirmation,
        meta: {
            requiresAuth: true
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async (to, _, next) => {
    window.scrollTo(0, 0);
    // Usuario con token guardado pero recien entra ala app
    if (store.getters.isLoggedIn && !store.getters['auth/getUser'].username) {
        const { data: user, error } = await store.dispatch('auth/getMe', null, {
            root: true
        });
        if (error || !user) next({ name: 'home' });
    }
    if (to.path === '/login') {
        next(
            store.getters.isLoggedIn
                ? {
                      name: 'Home'
                  }
                : undefined
        );
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        next(
            store.getters.isLoggedIn
                ? undefined
                : {
                      name: 'Login'
                  }
        );
    } else {
        next();
    }
});

export default router;
